export const regions = {
  western: {
    zoom: 7,
    location: [46.9967745294364, 93.72522509496832],
    regions: [
      "алтай",
      "баянхонгор",
      "өлгий",
      "улиастай",
      "ховд",
      "улаангом",
      "тосонцэнгэл",
    ],
  },
  central: {
    zoom: 7,
    location: [48.011706569490016, 102.2958779355153],
    regions: [
      "булган",
      "зуунмод",
      "мөрөн",
      "сүхбаатар",
      "цэцэрлэг",
      "арвайхээр",
      "хатгал",
    ],
  },
  eastern: {
    zoom: 7,
    location: [47.506069781910846, 113.13720703125001],
    regions: ["баруунурт", "чингис", "чойбалсан"],
  },
  gobi: {
    zoom: 7,
    location: [44.28847, 106.67725],
    regions: [
      "даланзадгад",
      "мандалговь",
      "сайншанд",
      "чойр",
      "замынүүд",
      "ханбогд",
    ],
  },
  cities: {
    zoom: 8,
    location: [48.758, 105.85876],
    regions: ["эрдэнэт", "улаанбаатар", "дархан"],
  },
  erdenet: {
    zoom: 11,
    location: [49.021660359632115, 104.27810668945314],
    regions: ["эрдэнэт"],
  },
  darkhan: {
    zoom: 9,
    location: [49.28930640196742, 106.31744384765626],
    regions: ["дархан"],
  },
  ulaanbaatar: {
    zoom: 9,
    location: [47.72085, 107.28149],
    regions: [
      "партизан",
      "налайх",
      "хануул",
      "багануур",
      "буянтухаа",
      "өлзийт",
      "баянзүрх",
    ],
  },
};
